"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHeaderRenderer = void 0;
const react_1 = __importDefault(require("react"));
const DialogWizard_1 = require("../../..");
function defaultHeaderRenderer({ title, description }) {
    return react_1.default.createElement(DialogWizard_1.DialogWizardContentHeader, { title: title, description: description });
}
exports.defaultHeaderRenderer = defaultHeaderRenderer;
//# sourceMappingURL=defaultHeaderRenderer.js.map